import React from "react";
import { Provider } from "react-redux";
import ReactOnRails from "react-on-rails";

import { TiMediaPiano } from "react-piano-manager";

/**
 * store provider for client
 * @require react-router or react component
 * @return { Provider }
 */
const mainNode = () => {
  const store = ReactOnRails.getStore("store");
  window.timedia_piano = new TiMediaPiano(store);

  return (
    <Provider store={store}>
      <div />
    </Provider>
  );
};

export default mainNode;
